import React, { PureComponent } from 'react'
import { Field, reduxForm, reset } from 'redux-form'
import { translate } from 'react-polyglot'
import { Form, Button, Text } from 'components'
import { Password } from 'components/FormField'
import { required, minLength6 } from 'utils/validation'

class ChangePasswordForm extends PureComponent {
	render() {
		const { handleSubmit, handleReset, error, reset, t } = this.props

		return (
			<Form
				onSubmit={handleSubmit}
				actions={
					<>
						<Button
							type="submit"
							layout="primary"
							text={t('confirm')}
						/>
						<Button
							type="reset"
							text={t('cancel')}
							onClick={e => {
								handleReset()
								reset()
							}}
						/>
					</>
				}
				error={error}
			>
				<Field
					name="currentPassword"
					label={t('forms.current_password')}
					component={Password}
					validate={[required, minLength6]}
					placeholder={t('forms.enter_password')}
					required
				/>
				<Field
					name="newPassword"
					label={t('forms.new_password')}
					component={Password}
					validate={[required, minLength6]}
					placeholder={t('forms.enter_new_password')}
					required
				/>
				{/* <Text size="small">
					Can&apos;t remember your current password?<br />
					<Button
						layout="underlined-text"
						text="Reset your password by email"
					/>
				</Text> */}
			</Form>
		)
	}
}

export default reduxForm({
	form: 'changePassword',
})(translate()(ChangePasswordForm))
